import React, { useEffect } from "react";
import { onBlankLayout } from "store/slices/themeSlice";
import { useDispatch, useSelector } from "react-redux";
import { USER_INFO } from "constants/AuthConstant";

const AppRoute = ({
  component: Component,
  routeKey,
  blankLayout,
  ...props
}) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const userInfo = JSON.parse(localStorage.getItem(USER_INFO));
  const isCompletedProfile = userInfo?.isCompletedProfile;

  useEffect(() => {
    const blankLayout =
      isCompletedProfile || auth.isCompletedProfile ? false : true;

    dispatch(onBlankLayout(blankLayout));
  }, []);

  return <Component {...props} />;
};

export default AppRoute;
